export const MAIN_CATEGORIES = [
    // 'All',
    'Lifestyle',
    'Gossip',
    'Cars',
    'Food',
    'Beauty',
    'Health',
    'Home Improvement',
    'Gadgets',
    'Business',
]